import type { Currency } from "@/api/types";
import { formatMoney, formatMoneySR } from "@/utils/format";
import "./money-amount.css";

export type MoneySize = "display" | "h1" | "body" | "caption";
export type MoneyTone = "neutral" | "owed" | "credit";

export interface MoneyAmountProps {
  value: number;
  ccy: Currency;
  size?: MoneySize;
  provisional?: boolean;
  tone?: MoneyTone;
  "data-testid"?: string;
}

export function MoneyAmount({
  value,
  ccy,
  size = "body",
  provisional = false,
  tone = "neutral",
  "data-testid": testId,
}: MoneyAmountProps) {
  const visible = formatMoney(value, ccy);
  const sr = formatMoneySR(value, ccy);
  const classes = [
    "wp-money",
    `wp-money--${size}`,
    `wp-money--${tone}`,
    provisional ? "wp-money--provisional" : null,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <span className={classes} data-testid={testId}>
      <span aria-hidden="true">{visible}</span>
      {provisional ? (
        <span
          aria-hidden="true"
          className="wp-money__asterisk"
          title="орієнтовно"
        >
          *
        </span>
      ) : null}
      <span className="visually-hidden">
        {provisional ? "орієнтовно " : ""}
        {sr}
      </span>
    </span>
  );
}
